import { generatePath } from "react-router-dom";
import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

const qs = (params) => (params ? new URLSearchParams(params).toString() : "");

export const getUserFollowers = async (userId, queryParams) => {
  const response = await axios.get(
    `${generatePath(apiRoutes.GET_USER_FOLLOWERS, { userId })}?${qs(queryParams)}`,
  );
  return response.data;
};

export const getUserFollowing = async (userId, queryParams) => {
  const response = await axios.get(
    `${generatePath(apiRoutes.GET_USER_FOLLOWING, { userId })}?${qs(queryParams)}`,
  );
  return response.data;
};

export const getShopFollowers = async (shopId, queryParams) => {
  const response = await axios.get(
    `${generatePath(apiRoutes.GET_SHOP_FOLLOWERS, { shopId })}?${qs(queryParams)}`,
  );
  return response.data;
};

export const getShopFollowing = async (shopId, queryParams) => {
  const response = await axios.get(
    `${generatePath(apiRoutes.GET_SHOP_FOLLOWING, { shopId })}?${qs(queryParams)}`,
  );
  return response.data;
};
